module.exports = __webpack_public_path__ + "partylineManage/img/tsLogo.202fcb30.png";